const moment = require("moment");

const Formatter = {}


Formatter.parseUnxiTime = (u, f="YYYY/MM/DD hh:mm:ss") => {
 return moment.unix(u/1000).format(f);
}

Formatter.parseDate = (t, org_f="YYYY-MM-DDThh:mm:ss.SSSZ") => {
  return moment(t, org_f, false);
}

Formatter.formatDateTime = (t, org_f="YYYY-MM-DDThh:mm:ss.SSSZ", to_f="YYYY/MM/DD hh:mm:ss") => {
  let m = moment(t, org_f, false);
  return m.format(to_f);
}
Formatter.formatDate = (t, org_f="YYYY-MM-DDThh:mm:ss.SSSZ", to_f="YYYY/MM/DD") => {
  let m = moment(t, org_f, false);
  return m.format(to_f);
}

Formatter.standarizeDate = (t, org_f="D.M.YYYY") => {
  let m = moment(t, org_f, false);
  return m.format("YYYY-MM-DD");
}

Formatter.formatReadableDate = (t, org_f="D.M.YYYY") => {
  let m = moment(t, org_f, false);
  return m.format("ddd, DD/MM");
}

Formatter.today = (f="YYYY-MM-DD") => {
  return moment().format(f);
}

Formatter.formatFileSize = (size) => {
  if (size < 1024) {
    return `${size.toFixed(2)} bytes`;
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} kB`;
  } else if (size < 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  } else {
    return `${(size / (1024 * 1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
}

export default Formatter;